import { graphql } from "@server/gql";

export const clearCartMutation = graphql(/* GraphQL */ `
  mutation clearCart($cartId: String!, $locale: String!) {
    cart: clearCart(cartId: $cartId, locale: $locale) {
      ...cart
    }
  }
`);
